import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import clsx from "classnames";
import revealStyles from "../../../components/PokemonReveal/PokemonReveal.module.scss";

/**
 * FoeEntranceAnimation – plays the Poké Ball throw inside the foe sprite wrapper
 * so that positioning is always correct on any screen size.
 *
 * Props
 *   opponentRef : ref to the <img class="wild-front"> element
 *   onComplete  : callback fired when the throw animation ends
 */
export default function FoeEntranceAnimation({ opponentRef, onComplete }) {
  const [parentEl, setParentEl] = useState(null);
  const [pos, setPos] = useState(null);

  // Hide foe sprite, grab its wrapper, and compute center position inside wrapper
  useEffect(() => {
    const img = opponentRef?.current;
    if (!img) return;

    const wrapper = img.parentElement;
    setParentEl(wrapper);

    const computePos = () => {
      const imgRect = img.getBoundingClientRect();
      const wrapRect = wrapper.getBoundingClientRect();
      setPos({
        left: imgRect.left - wrapRect.left + imgRect.width / 2,
        top: imgRect.top - wrapRect.top + imgRect.height / 2,
      });
    };

    computePos();
    window.addEventListener("resize", computePos);

    // hide during animation
    img.style.visibility = "hidden";

    return () => {
      window.removeEventListener("resize", computePos);
      img.style.visibility = "visible";
    };
  }, [opponentRef]);

// second effect to unhide sprite and call onComplete after duration
  useEffect(() => {
    if (!parentEl) return;
    const t = setTimeout(() => {
      if (opponentRef?.current) {
        // Reset both visibility and transform to fix positioning bug
        opponentRef.current.style.visibility = "visible";
        opponentRef.current.style.transform = "none";
      }
      onComplete?.();
    }, 1600);
    return () => clearTimeout(t);
  }, [parentEl, onComplete, opponentRef]);

  // return markup or null based on parentEl presence
  


  const ballMarkup = (
    <div
      className={clsx(revealStyles.revealWrapper, "foeAnim")}
      style={{ position: "absolute", left: pos?.left, top: pos?.top, transform: "translate(-50%, -50%)", pointerEvents: "none" }}
    >
      <div
        className={clsx(revealStyles.pkmn, revealStyles.exit, revealStyles.right)}
      >
        <div className={clsx(revealStyles.poke, revealStyles.ball, revealStyles.throw)}>
          <span className={revealStyles.x}>
            <span className={revealStyles.y}>
              <span className={revealStyles.sprite} />
            </span>
          </span>
        </div>
      </div>
    </div>
  );

  return parentEl && pos ? ReactDOM.createPortal(ballMarkup, parentEl) : null;
}
